import request from 'assets/js/http';

export function login(data) {
  return request({
    url: '/common/okta/login',
    method: 'post',
    data
  });
}
export function stateList() {
  // 获取阶段列表
  return request({
    url: '/state/list',
    method: 'post'
  });
}
export function stateDelete(data) {
  // 删除阶段
  return request({
    url: '/state/delete',
    method: 'post',
    data
  });
}
export function stateAction(data) {
  // 新增-修改 阶段
  let url = '/state/add';
  if (data.id || data.id === 0) {
    url = '/state/edit';
  }
  return request({
    url: url,
    method: 'post',
    data
  });
}
// 获取用户-列表
export function searchNickName(searchName) {
  return request({
    url: '/account/listSimple',
    method: 'post',
    data: {
      searchName
    }
  });
}
export function searchNickNamePage(searchName, page = 1) {
  // 分页
  return request({
    url: '/account/listSimple',
    method: 'post',
    data: {
      searchName,
      page
    }
  });
}
// 获取用户-列表分页信息
export function searchByName(searchName) {
  return request({
    url: '/account/listSimple',
    method: 'post',
    data: {
      page: 1,
      pageSize: 300,
      searchName
    }
  });
}
export function searchAllByName(searchName) {
  return request({
    url: '/account/listSimple',
    method: 'post',
    data: {
      page: 1,
      pageSize: 300,
      ifAll: true,
      searchName
    }
  });
}
export function search(data) {
  // 搜索
  return request({
    url: '/search/list',
    method: 'post',
    data
  });
}
// 文件预览
export function viewFile(data) {
  return request({
    url: '/file/view',
    method: 'post',
    data: data
  });
}
// 文件下载
export function downloadFile(data) {
  return request({
    url: '/file/download',
    method: 'post',
    data: data
  });
}

//获取公共列表（meetingPersons-用户组，category-上会分类，goals-上会目的，tplChoices-会议模版，
// meetingRooms-会议室，roundList-项目轮次，decisionPoint-投资决策节点，expertDimension-专家访谈维度）
export function getCommonList() {
  return request({
    url: '/common/getCommonList',
    method: 'post'
  });
}

export function getMatchPosition(data) {
  return request({
    url: '/common/getCommonAddress',
    method: 'post',
    data
  });
}

// 图片上传
export function uploadImage(data) {
  return request({
    url: '/upload/commonImg',
    headers: {
      'content-type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  });
}

//查询轮次
export function roundList(data) {
  return request({
    url: '/common/roundList',
    method: 'post',
    data
  });
}

//查询轮次simple
export function roundSimpleList(data) {
  return request({
    url: '/common/roundSimpleList',
    method: 'post',
    data
  });
}

// 获取IC-列表
export function getICList(category) {
  return request({
    url: '/account/getICList',
    method: 'post',
    data: {
      category
    }
  });
}
export function uploadFile(data) {
  return request({
    url: '/upload/companyFile',
    method: 'post',
    data
  });
}

export function uploadOfflineNeetingFile(data) {
  return request({
    url: '/upload/uploadOfflineMeetingProjectAudio',
    method: 'post',
    data
  });
}

export function getJsapiTicket() {
  return request({
    url: '/common/lark/getJsapiTicket',
    method: 'post'
  });
}

export function getBuList() {
  return request({
    url: '/common/getBuList',
    method: 'post'
  });
}
//根据用户ID查询所在部门人数
export function queryDepartmentUserCountsByUserId(userId) {
  return request({
    url: '/account/queryDepartmentUserCountsByUserId',
    method: 'post',
    data: {
      userId
    }
  });
}
